import React from 'react'
import { logo } from '../constants/files'

const NotFound = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3">
            <img src={logo} alt="Logo de l'entreprise" className="mb-3" style={{ height: "80px" }} />
            <i className="text-warning fa fa-exclamation-triangle fs-1" />
            <h1 className="mt-3 fw-bold text-light">404 - Page Introuvable</h1>
            <p className="text-white-50">
                La page que vous recherchez n'existe pas ou a été déplacée.
            </p>
            <a href="/" className="bgcolor-primary px-4 py-2 rounded-pill">
                <span className=' text-white'>Retour à l'accueil</span>
            </a>
        </div>
    )
}

export default NotFound